export const data = () => ({
  optionsSelected: [],
  options: [],
  options_default: [
    {
      id: 10,
      name: 'Data Da Triagem',
      children: [
        {
          id: 'data_inicio_triagem',
          name: 'De',
        },
        {
          id: 'data_fim_triagem',
          name: 'Até',
        },
      ],
    },
    {
      id: 20,
      name: 'Data Da Movimentação',
      children: [
        {
          id: 'data_inicio',
          name: 'De',
        },
        {
          id: 'data_fim',
          name: 'Até',
        },
      ],
    },
    {
      id: 30,
      name: 'Fornecedor',
      children: [
        {
          id: 'fornecedor',
          name: 'Fornecedor',
        },
        {
          id: 'produto',
          name: 'Produto',
        },
        {
          id: 'sub_produto',
          name: 'Sub Produto',
        },
      ],
    },
    {
      id: 60,
      name: 'Veículo',
      children: [
        {
          id: 'motorista',
          name: 'Motorista',
        },
        {
          id: 'placa_cavalo',
          name: 'Placa',
        },
        {
          id: 'eixo',
          name: 'Eixo',
        },
      ],
    },
  ],
  options_aditional: [
    {
      id: 40,
      name: 'Contratos',
      children: [
        {
          id: 'terminal',
          name: 'Terminal',
        },
        {
          id: 'servico',
          name: 'Serviço',
        },
        {
          id: 'armazem',
          name: 'Armazem',
        },
        {
          id: 'cliente',
          name: 'Cliente',
        },
        {
          id: 'transportadora',
          name: 'Transportadora',
        },
      ],
    },
    {
      id: 50,
      name: 'Região',
      children: [
        {
          id: 'regiao',
          name: 'Região',
        },
        {
          id: 'representante',
          name: 'Representante',
        },
      ],
    },
  ],
})
